import { createSlice } from '@reduxjs/toolkit'

import type { PayloadAction } from '@reduxjs/toolkit'

export enum PopupId {
  SignOut,
  Download,
  ApplyToJob,
  NotificationOldUser,
  NotificationNewUser,
  EulaAgreement,

  // Soundscape page popups
  SoundscapeFeel,
  SoundscapeSmart,
  SoundscapeZone,
  SoundscapeVoice,
  SoundscapeSafe,
}

export interface SoundscapeDemoPopupContent {
  logoUrl: string
  title: string
  description: string
}

export interface PopupState {
  activePopup: PopupId | null
  soundscapeDemoContent: SoundscapeDemoPopupContent | null
}

const initialState: PopupState = {
  activePopup: null,
  soundscapeDemoContent: null,
}

export const popupSlice = createSlice({
  name: 'popup',
  initialState,
  reducers: {
    showPopup: (state, action: PayloadAction<PopupId>) => {
      state.activePopup = action.payload
      state.soundscapeDemoContent = null
    },
    showSoundscapeDemoPopup: (
      state,
      action: PayloadAction<{ popupId: PopupId, content: SoundscapeDemoPopupContent }>,
    ) => {
      state.activePopup = action.payload.popupId
      state.soundscapeDemoContent = action.payload.content
    },
    closePopup: (state) => {
      state.activePopup = null
      state.soundscapeDemoContent = null
    },
  },
})

export const { showPopup, showSoundscapeDemoPopup, closePopup } = popupSlice.actions
export default popupSlice.reducer
